import { Toaster } from 'sonner';
import { useThemeStore } from '@/stores/themeStore';

export function ToastProvider() {
  const theme = useThemeStore((s) => s.theme);
  const resolvedTheme = theme === 'system'
    ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    : theme;

  return (
    <Toaster
      theme={resolvedTheme}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        duration: 4000,
      }}
    />
  );
}
